import {
  create_icon_default
} from "../chunk-PDMSKZZD.js";
import "../chunk-G6JHNJEL.js";

// icons/RotateCwIcon.ts
var RotateCwIcon = create_icon_default("RotateCw", [
  ["path", { d: "M21 2v6h-6", key: "1lwg0q" }],
  ["path", { d: "M21 13a9 9 0 1 1-3-7.7L21 8", key: "vix499" }]
]);
export {
  RotateCwIcon
};
